
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormDSVUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { COURSES } from '../../../shared/constants';

export const CompetitionResultForm = ({ initData, onDataChanged, onFileChanged, fileType }) => {
  const [newCompetitionData, setNewCompetitionData] = useState({ ...initData });

  useEffect(() => {
    setNewCompetitionData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newCompetitionData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewCompetitionData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
        <FormItem>
          <FormDSVUploader onValueChange={onFileChanged} fileType={fileType}/>
        </FormItem>
      </GroupItem>

    
    </Form>
  );
};
